import React from 'react';
import ContactUsButton from '../components/ContactUsButton';

const FitnessAreaRulesPage: React.FC = () => {
  return (
    <div className="page-container">
      <div className="services-page">
        <div className="services-container">
          <p className="breadcrumb">Services / Fitness Area</p>
          <h1 className="page-title">Fitness Area</h1>
          <p className="page-subtitle">
            Guidelines and information for using the fitness area at TDS Event Center.
          </p>
          <div className="page-header-actions">
            <ContactUsButton
              buttonText="Click here to ask questions"
              className="contact-button contact-button-alt"
              defaultService="Fitness Area"
              defaultInquiry="information"
            />
          </div>

          <div className="rules-section">
            <h2>General Usage</h2>
            <ul>
              <li>The fitness area is available during posted facility hours.</li>
              <li>Appropriate athletic attire and closed-toe shoes are required.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Equipment Guidelines</h2>
            <ul>
              <li>Please follow instructions and safety labels on all equipment.</li>
              <li>Wipe down equipment after use with provided cleaning supplies.</li>
              <li>Return free weights and accessories to their proper storage locations.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Safety &amp; Conduct</h2>
            <ul>
              <li>Report any damaged equipment to staff immediately.</li>
              <li>Be mindful of other users and share equipment during busy times.</li>
              <li>Music and personal devices should be used with headphones.</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default FitnessAreaRulesPage;


